<template>
  <div>
    <div :class="data.class" class="user-input user-input-textarea">
      <p v-if="data.props.defaultValue" style="display: inline">{{ data.props.defaultValue }}
        <footnotes v-if="data.props.footnotes" :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
      </p>
      <p v-else style="display: inline">- - -
        <footnotes v-if="data.props.footnotes" :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
      </p>
    </div>
  </div>
</template>

<script>
import Footnotes
  from "./Footnotes.vue"

export default {
  name: 'TEXTAREA',
  components: {Footnotes},
  props: ['data', 'footnotes'],
}
</script>

<style>
.user-input {
  //margin-bottom: 15px;
  border: 1px dashed #aaa;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// TEXTAREA.vue?515a468b